export default __webpack_public_path__ + "static/media/30.91bb2921.jpeg";